import * as React from 'react';
import { ArrowLeft, ArrowRight } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import { Button } from '../../Button/src/Button.js';
import { Space } from '../../Space/src/Space.js';
import modules_2fd5ce57 from '../styles/Arrows.module.less.js';

/** Inner sub-component for Carousel */
const Arrows = React.forwardRef((props, ref) => {
    const { isPrevDisabled, isNextDisabled, onPrevClick, onNextClick, ...restProps } = props;
    const cx = useStyles(modules_2fd5ce57);
    return (React.createElement(Space, { ref: ref, align: "end", justify: "end", size: 12, className: cx('arrows', 'important'), ...restProps },
        React.createElement(Button, { onClick: onPrevClick, variant: "secondary", size: 36, disabled: isPrevDisabled, className: modules_2fd5ce57.button },
            React.createElement(ArrowLeft, { className: modules_2fd5ce57.icon })),
        React.createElement(Button, { onClick: onNextClick, variant: "secondary", size: 36, disabled: isNextDisabled, className: modules_2fd5ce57.button },
            React.createElement(ArrowRight, { className: modules_2fd5ce57.icon }))));
});
Arrows.displayName = 'Arrows';

export { Arrows };
//# sourceMappingURL=Arrows.js.map
